/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_Datafetching1Inputs */

const he_header_datafetching1 = /** @type {(inputs: Header_Datafetching1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שליפת נתונים`)
};

const en_header_datafetching1 = /** @type {(inputs: Header_Datafetching1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Fetching`)
};

/**
* | output |
* | --- |
* | "Data Fetching" |
*
* @param {Header_Datafetching1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const header_datafetching1 = /** @type {((inputs?: Header_Datafetching1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_Datafetching1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_header_datafetching1(inputs)
	return en_header_datafetching1(inputs)
});
export { header_datafetching1 as "header_dataFetching" }